import { createFileRoute } from '@tanstack/react-router';

import { TaxSettings } from '@/features/tax/components/tax-settings';

export const Route = createFileRoute('/_authenticated/$tenantId/settings/tax')({
  component: TaxSettings,
});
